module.exports = __webpack_public_path__ + "img/2.69b63a43.jpg";